<template>
    <div  class="container-fluid px-lg-2 px-xl-4">
        <div class="row d-flex align-items-center">
			<div class="col-12 col-sm-7 pl-0">
				<nav aria-label="breadcrumb ">
					<ol class="breadcrumb pl-0">
						<li class="breadcrumb-item">Reimprimir recibos</li>
					</ol>
				</nav>
			</div>
		</div>
        <div class="row bg-white mb-2 ">

        </div>
        <div class="row bg-white mb-2 ColorAzul h5" ref="ancla">
            <div class="col-12">
                <div class="row">
                    <div class="col-6 col-md-2">
                        <span class="etiqueta-fecha">Desde:</span>
                    </div>
                    <div class="col-6 col-md-2">
                        <span class="etiqueta-fecha">Hasta:</span>
                    </div>
                </div>
                <div class="row mb-2 d-flex align-items-center">
                    <div class="col-6 col-md-2 mb-2">
                        <datepicker
                            :format="format"
                            :language="languages['es']"
                            input-class="form-control form-control-sm font-12 bg-white"
                            v-model="fechaInicio"
                            :disabled-dates="{ from: new Date() }"
                        />
                    </div>
                    <div class="col-6 col-md-2 mb-2">
                        <datepicker
                            :format="format"
                            :language="languages['es']"
                            input-class="form-control form-control-sm font-12 bg-white"
                            v-model="fechaFin"
                            :disabled-dates="{ from: new Date() }"
                        />
                    </div>
                    <div class="col-12 col-md-2 mb-2 d-flex d-inline-block">
                        <button class="btn form-control ColorAzul font-12 ButtonConsultar" 
                                @click="consultarFoliosCobranza">
                            Consultar
                        </button>

                        <router-link class="btn btn-outline-info btn-sm ml-2" to="/clientes/referenciarpagos">Regresar</router-link>
                    </div>
                </div>
            </div> 
        </div> 

        <div class="row">
            <table class="table tabla-folios table-sm font-12 mt-2">
                <thead>
                    <tr class="text-white">
                        <th class="text-center p-2 align-middle">Folio</th>
                        <th class="text-center p-2 align-middle">Fecha Referenciado</th>
                        <th class="text-center p-2 align-middle"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr  
                        v-bind:key="item.folioCobranza" 
                        v-for="item in folios" 
                        class="bg-white" >
                        <td class="text-center align-middle ColorAzul">
                            <div class="">{{item.folioCobranza}}-{{ item.serie }}</div>
                        </td>
                        <td class="text-center align-middle ColorAzul">
                            <div class="">{{item.fechaDeposito | format-date('DD/MMM/YYYY')}}</div>
                        </td>
                        <td class="text-center align-middle ColorAzul">
                            <button class="btn btn-sm btn-outline-warning"
									@click="descargarFolios(item.folioCobranza, item.codAgente)">
                                    <!-- <span class="d-none d-lg-block">
                                        Descargar
                                    </span>  -->
									<i class="fas fa-download"></i>
							</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- paginador -->
        <div class="row">
            
            <div class="col-12 pt-3 d-flex justify-content-center">
                <ul class="pagination">
                    <li class="page-item" v-show="paginaActual > 1">
                        <a  @click="navegar(1)" 
                            class="page-link" 
                            role="button">«</a>
                    </li>
                    <li class="page-item">
                        <a
                            @click="navegar(paginaActual-1)"
                            class="page-link text-decoration-none d-none d-md-block"
                            role="button"
                            v-if="paginaActual > 1 && folios != null"
                        >Anterior</a>
                    </li>
                    <li :class="{active: paginaActual == pag}" 
                        :key="pag" 
                        class="page-item" 
                        v-for="pag in paginador">
                        <a  @click="navegar(pag)"
                            class="page-link">{{pag}}</a>
                    </li>
                    <li class="page-item" 
                        v-if="folios != null && folios.length > 0 && paginaActual < totalPaginas">
                        <a  @click="navegar(paginaActual+1)" 
                            class="page-link text-decoration-none d-none d-md-block" 
                            role="button">Siguiente</a>
                    </li>
                    <li class="page-item" 
                        v-show="paginaActual < totalPaginas">
                        <a  @click="navegar(totalPaginas)" 
                            class="page-link" 
                            role="button">»</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import servicio from "@/services/servicio-referenciar-pagos-reimpirmir-recibo"
import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js"
import * as lang from "vuejs-datepicker/src/locale"

export default {
    data(){
        return{
            fechaInicio: new Date(),
			fechaFin: new Date(),
            languages: lang,
            format: "dd/MMM/yyyy",
            paginaActual:1,
            totalPaginas:1,
            paginador:[],
            folios:[]
        }
    },
    components:{
        Datepicker
    },
    mounted(){
        var d = new Date()
        d.setDate(d.getDate()-7)
        this.fechaInicio = d
        this.fechaInicio = new Date(d.getFullYear(), d.getMonth(), d.getDate())

        this.consultarFoliosCobranza()
    },
    methods: {
        navegar(pag){
            this.paginaActual = pag
            this.consultarFoliosCobranza()
            this.scrollMeTo('ancla')
        },
        descargarFolios(folio, codAgente){
            this.$loading(true)
            servicio.imprimirRecibo(folio, codAgente)
                .then(r => {
                    this.$loading(false)
                    const downloadLink = document.createElement("a");
                    const fileName = String(this.usuarioGlobal().codCliente) + '-' + r.data.folio + r.data.serie;

                    downloadLink.href = 'data:application/pdf;base64,' + r.data.recibo;
                    downloadLink.download = fileName;
                    downloadLink.click();
                })
                .catch( err => {
                    this.$loading(false)
                    console.log('imprimirRecibo', err)
                }) 
        },
        consultarFoliosCobranza(){
            this.fechaInicio.setHours(7, 0, 0, 0)
            let finicio = new Date(this.fechaInicio.getFullYear(), this.fechaInicio.getMonth(), this.fechaInicio.getDate())
            this.fechaFin.setHours(7, 0, 0, 0)
            let ffin = new Date(this.fechaFin.getFullYear(), this.fechaFin.getMonth(), this.fechaFin.getDate())

            this.$loading(true)
            servicio.consultarFoliosCobranza(finicio, ffin,this.paginaActual)
                .then(r => {
                    console.log(r)
                    this.$loading(false)
                    this.folios = r.data.recibos
                    this.totalPaginas = r.data.totalPaginas
                    this.paginas()
                })
                .catch( err => {
                    this.$loading(false)
                    console.log('consultarFoliosCobranza', err)
                }) 
        },
        paginas() {
				const pagina = Number(this.paginaActual)
				const totPaginas = Number(this.totalPaginas)
                
                //console.log('totPaginas, pagina', totPaginas,pagina)
				if (pagina == null || totPaginas == null) return []

				let res = []
				const max = 5
				let aux = Math.floor(max / 2)

				let inicio = pagina - aux > 0 ? pagina - aux : 1

				let fin = pagina + aux > totPaginas ? totPaginas : pagina + aux

				for (let i = inicio; i <= fin; i++) {
					res.push(i)
				}

				this.paginador = res
			},
    },
    computed: {
        
    }

}
</script>
<style scoped lang="scss">
.tabla-folios {
    background-color: var(--color-azul) !important;
}
.ColorAzul {
    color: var(--color-azul);
}
.ButtonConsultar:hover {
    background: var(--color-azul);
    color: white;
}
.ButtonConsultar {
    width: 100%;
    height: 30px;
    border: 1px solid var(--bg-menu-blue);
    border-radius: 5px;
}
.etiqueta-fecha{
    color: var(--color-azul) !important;
    font-size: 15px;
}
</style>